import styled from 'styled-components';

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: minmax(250px, 780px);
  border: 2px solid #767373;
  justify-content: center;
  background-color: #cbcbcb;
`;

export const UsersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
`;

export const StyledWrapperCards = styled.div`
  /* TODO: Estilos que se repiten en otro wrapper, ver si se mueven a un style global */
  display: grid;
  grid-row-gap: 16px;
  @media screen and (min-width: 768px) {
    grid-row-gap: 32px;
  }
  /* cuando esto esta habilitado no se ven los organism_selector */
  /* position: relative; */

  && .CardBase--shaded {
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.14);
  }
  && .CardBase_content--no-padding > div {
    padding-right: 16px;
    padding-left: 16px;
    @media screen and (min-width: 768px) {
      padding-right: 32px;
      padding-left: 32px;
    }
  }
  & .CardBase > header {
    padding: 16px 16px;
    @media screen and (min-width: 768px) {
      padding: 20px 32px;
    }
  }
  & .CardBase--titles {
    row-gap: 4px;
  }
  & .CardBase--titles > h2 {
    font-size: 18px;
    line-height: 24px;
    font-weight: 500;
    @media screen and (min-width: 768px) {
      font-size: 24px;
      line-height: 30px;
    }
  }
  & .CardBase--titles > h4 {
    font-size: 14px;
    line-height: 20px;
  }
  & .CardBase p {
    font-size: 14px;
  }
  & .CardBase .title-content {
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
  }
  & .CardBase .subtitle-content {
    font-size: 14px;
    line-height: 20px;
  }
  & .CardBase .text-content {
    font-size: 14px;
    line-height: 22px;
  }

  /* TODO: Estilos que se repiten en otro wrapper, ver si se mueven a un style global */
  & .Autocomplete-selector {
    & label {
      font-size: 14px;
      font-weight: bold;
      color: #383638;
    }
    & .Autocomplete-input-wrapper input {
      font-size: 14px;
      color: #383638;
    }
    & .Autocomplete-list li {
      font-size: 14px;
      color: #383638;
    }
  }
  /* TODO: Fin estilos repetidos */
`;

export const Rut = styled.div`
  & > span:nth-child(1) {
    font-weight: bold;
    display: block;
  }
`;
export const StyledRut = styled.div`
  & > span:nth-child(1) {
    font-weight: bold;
    display: block;
  }
`;

export const StyledGridWrapper = styled.div`
  display: grid;
  grid-row-gap: 16px;
  @media screen and (min-width: 768px) {
    grid-template-columns: 1fr 1fr 1fr;
    grid-column-gap: 20px;
  }
`;

export default Wrapper;
